import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
// import 'rxjs/add/operator/map';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse
} from '@angular/common/http';
import { AuthService } from './auth.service';
// import 'rxjs/Rx';
// import { Observable } from "rxjs/Rx";
import { map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { LoaderService } from '../shared/loader.service';
import { MissingCapabilityService } from '../missing-capability/missing-capability.service';
declare var $: any;
import * as moment from 'moment-timezone';


@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

    private httpCount = 0;
    constructor(
        public _authService: AuthService,
        public _router: Router,
        public _loaderService: LoaderService,
        private _missingCapabilityService: MissingCapabilityService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let hideLoader = request.headers.get('hideLoader') == 'true' ? true : false;
        //  console.log("hide Loader is ", hideLoader);
        if (!hideLoader) {
            // false is string because we cannot set boolean values in headers
            // console.log("increasing the http count from ", this.httpCount);
            this.httpCount += 1;
            // console.log(this.httpCount);
            this._loaderService.changeLoadingVisibility(true);
        }

        /**
         * * @constant ignore determines whether to ignore the header 'Content-Type' 
         */
        let ignore =
        typeof request.body === 'undefined'
        || request.body === null
        || request.body.toString() === '[object FormData]'
        || request.headers.has('Content-Type');

        /*
         * * Header Content-Type will be passed only if the above statement pass
         */
        if (!ignore) {
            request = request.clone({
                headers: request.headers.set('Content-Type', 'application/json')
            });
        }

        request = request.clone({
            headers: request.headers
                .set('x-header-authtoken', this._authService.getAuthToken())
                .set('x-header-refreshtoken', this._authService.getRefreshToken())
                .set('timezone', moment.tz.guess())
        });
        return next.handle(request).pipe(
            map((res: HttpResponse<any>) => {

                if (res.body) {
                    // console.log("request is ended with result ", res);
                    if (this.httpCount > 0) {
                        // console.log("decreasing the http count from", this.httpCount);
                        this.httpCount -= 1;
                        // console.log(this.httpCount);
                    }
                    if (this.httpCount === 0) {
                        this._loaderService.changeLoadingVisibility(false);
                    }
                    if (res.body.data && res.body.data.tokens) {
                        this._authService.setAuthToken(res.body.data.tokens.authToken);
                        this._authService.setRefreshToken(res.body.data.tokens.refreshToken);
                    }
                    return res;
                }
            }),
            catchError((error: any) => {
                // console.log("request is ended with error in response", error);
                if (this.httpCount > 0) {
                    // console.log("decreasing the http count from", this.httpCount);
                    this.httpCount -= 1;
                    // console.log(this.httpCount);
                }
                if (this.httpCount === 0) {
                    this._loaderService.changeLoadingVisibility(false);
                }
                if (error.status === 401 || error.statusText === 'Unauthorized' || (error.error && error.error.message === 'invalid token')) {
                    localStorage.clear();
                    this._authService.clearAllCookies();
                    $('#deactivateModal').modal({
                        backdrop: 'static',
                        show: true
                    });
                } else if (error.status === 403) {
                    // call the alert service.
                    this._missingCapabilityService.open();
                    // this._router.navigateByUrl('/login');
                } else {
                    return Observable.throw(error);
                }
            }));
    }
}




// WEBPACK FOOTER //
// ./src/app/auth/http-interceptor.service.ts